import { useCallback, useState } from 'react';
import { ConfirmModal, useModalContext } from '@fourthwall/components';
import { useDashboardStorage } from '@hooks/useDashboardStorage';
const KEYS = [
    'campaign',
    'addReferralLinkToHomepage',
    'createProduct',
    'creatorApp',
    'creatorChallenge',
    'digitalProduct',
    'domain',
    'freeShipping',
    'googleAnalytics',
    'helpCenter',
    'integrations',
    'invite',
    'joinDiscord',
    'memberships',
    'orderSamples',
    'ordersToSend',
    'payouts',
    'promotions',
    'referral',
    'social',
    'thankYou',
    'twitchGifting',
    'twitchPromotion',
    'youTubeProductShelf',
];
export const useRecommendationsDismiss = () => {
    const { dashboardStorage } = useDashboardStorage();
    const { open } = useModalContext();
    const initialVisibility = KEYS.reduce((acc, key) => ({
        ...acc,
        [key]: !dashboardStorage.get(`recommendationsDismiss.${key}`),
    }), {});
    const [visibility, setVisibility] = useState(initialVisibility);
    const dismiss = (key) => {
        setVisibility((prev) => ({ ...prev, [key]: false }));
        dashboardStorage.set(`recommendationsDismiss.${key}`, true);
    };
    const recommendationsDismiss = KEYS.reduce((acc, key) => ({
        ...acc,
        [key]: { visible: visibility[key], dismiss: () => dismiss(key) },
    }), {});
    const createOnDismiss = (onConfirm) => () => {
        open(ConfirmModal, {
            title: 'Are you sure you want to hide this recommendation?',
            text: 'This action cannot be reversed.',
            confirmLabel: 'Hide recommendation',
            onConfirm,
        });
    };
    const createOnDismissCallback = useCallback((onConfirm) => {
        return () => {
            open(ConfirmModal, {
                title: 'Are you sure you want to hide this recommendation?',
                text: 'This action cannot be reversed.',
                confirmLabel: 'Hide recommendation',
                onConfirm,
            });
        };
    }, [open]);
    return { recommendationsDismiss, createOnDismiss, createOnDismissCallback };
};
